interface IDtpScriptOptions {
  dtpBaseUrl: string
  /** /succes и /seif: ссылки появляются позже, тегирование только через retailOfferLinks() */
  isWheelPath: boolean
  gtmEnabled: boolean
}

// Текст инлайн-скрипта Voluum DTP + тегирования ссылок офферов (вставляется в index.tsx).
export function getDtpScriptText({ dtpBaseUrl, isWheelPath, gtmEnabled }: IDtpScriptOptions) {
  return `
    (function () {
      // Обёрнуто в IIFE: Cookiebot клонирует и повторно вставляет отложенные
      // скрипты в DOM (dequeueNonAsyncScripts), и при повторном выполнении
      // верхнеуровневые const/let ловили "Identifier has already been declared".
      const transactionID = Math.random().toString(36).substr(2, 9) + Date.now();
      const urlParams = new URLSearchParams(window.location.search);
      const DTP_BASE_URL = ${JSON.stringify(dtpBaseUrl)};

      (function(b,c,h,p,q,e,r,w,d,k,t,a,l,m,f,n,u,g){function v(){for(var a=c.querySelectorAll(".dtpcnt"),b=0,d=a.length;b<d;b++)a[b][r]=a[b][r].replace(/(^|\\s+)dtpcnt($|\\s+)/g,"")}b[d]||(b[d]=function() {(b[d].q=b[d].q||[]).push(arguments)},m=c[p],c[p]=function() {m&&m.apply(this,arguments);if(b[d]&&!b[d].hasOwnProperty("params")&&/loaded|interactive|complete/.test(c.readyState))for(;a=c[q][k++];)/\\/?click($|(\\/[0-9]+)?$)/.test(a.pathname)&&(a[e]="javascrip"+b.postMessage.toString().slice(4,5)+":"+d+'.l="'+ a[e]+'",void 0')},setTimeout(function(){(n=/[?&]cpid(=([^&#]*)|&|#|$)/.exec(b.location.href))&&n[2]&&(f=n[2],u=c.cookie.match(new RegExp("(^| )vl-"+f+"=([^;]+)")));a=c.createElement("script");l=c.scripts[0];a.defer=1;a.src=t+(-1===t.indexOf("?")?"?":"&")+"lpref="+h(c.referrer)+"&lpurl="+h(location[e])+"&lpt="+h(c.title)+"&t="+(new Date).getTime()+(u?"&uw=no":"");a[w]=function(){for(k=0;a=c[q][k++];)/dtpCallback\\.l/.test(a[e])&&(a[e]=a[e].match(/dtpCallback\\.l="([^"]+)/)[1]);v()};l.parentNode.insertBefore(a, l);f&&(g=new Date,g.setTime(g.getTime()+864E5),c.cookie="vl-"+f+"=1; expires="+g.toGMTString()+"; path=/")},0),setTimeout(v,7E3))})(window,document,encodeURIComponent,"onreadystatechange","links","href","className","onerror","dtpCallback",0, DTP_BASE_URL + "?order_id=" + transactionID);
      (function () {
        const TIMES = 30; // retry ceiling (~15s); fires as soon as DTP + cards are ready.
        const INTERVAL = 500;
        let attempts = 0;
        // На /succes ссылка на лендера появляется только после спина колеса (когда угодно,
        // не в первые ~15с) — это не ошибка, поэтому eager-опрос при загрузке тут не нужен
        // (иначе "offer cards not found" ушёл бы в Sentry почти при каждом заходе).
        // Тегирование там делает retailOfferLinks(), вызываемый явно при показе лендера.
        // На /seif так же: ссылки рендерятся только после открытия сейфа.
        const IS_WHEEL_PATH = ${JSON.stringify(isWheelPath)};

        // Offer cards render as <a class="link" id="<offerId>">.
        function offerAnchors() {
          return document.querySelectorAll('a.link[id]');
        }

        function report(message, err) {
          if (window.Sentry && window.Sentry.captureException && err) {
            window.Sentry.captureException(err);
          } else if (window.Sentry && window.Sentry.captureMessage) {
            window.Sentry.captureMessage(message);
          } else {
            console.warn(message, err || '');
          }
        }

        // Removes Voluum's cep= tail. The DTP script tails /click links on its own when it
        // loads, so cards rendered before that are already tailed at our first snapshot.
        function stripTail(href) {
          if (!/[?&]cep=/.test(href)) return href;
          var hashAt = href.indexOf('#');
          var hash = hashAt < 0 ? '' : href.slice(hashAt);
          var base = hashAt < 0 ? href : href.slice(0, hashAt);
          var queryAt = base.indexOf('?');
          if (queryAt < 0) return href;
          var params = base.slice(queryAt + 1).split('&').filter(function (p) {
            return p && p.indexOf('cep=') !== 0;
          });
          return base.slice(0, queryAt) + (params.length ? '?' + params.join('&') : '') + hash;
        }

        // generateLinks appends a tracking tail in place and is NOT idempotent.
        // Snapshot each pre-tail href and restore it before generating, so repeated
        // runs leave exactly one tail (else the URL keeps growing → 414).
        function generate() {
          var anchors = offerAnchors();
          for (var i = 0; i < anchors.length; i++) {
            var a = anchors[i];
            if (a.dataset.pristineHref == null) {
              a.dataset.pristineHref = stripTail(a.getAttribute('href') || '');
              a.setAttribute('href', a.dataset.pristineHref);
            } else {
              a.setAttribute('href', a.dataset.pristineHref);
            }
          }
          window.dtpCallback.generateLinks();
        }

        function attemptGenerateLinks() {
          attempts++;

          const ready =
            window.dtpCallback &&
            typeof window.dtpCallback.generateLinks === 'function';

          // Tail only when DTP is loaded AND cards exist — too early → no tail → 400.
          if (ready && offerAnchors().length > 0) {
            try {
              generate();
              return;
            } catch (err) {
              // Transient throw: don't return, let the loop retry.
              report('generateLinks threw', err);
            }
          }

          if (attempts < TIMES) {
            setTimeout(attemptGenerateLinks, INTERVAL);
          } else if (ready) {
            // DTP loaded but no cards matched — fire once as a safety net and report.
            report('generateLinks: offer cards not found, firing once as fallback');
            try { generate(); } catch (err) { report('generateLinks fallback threw', err); }
          } else {
            report('generateLinks: DTP script never loaded after all retries');
          }
        }

        if (!IS_WHEEL_PATH) {
          attemptGenerateLinks();
        }

        // Re-tail on demand. Rotation/reset re-renders the offer cards and may
        // remount anchors (offers move between the best/cards lists), leaving fresh
        // <a> nodes with a pristine, untailed href → 400. OfferWall calls this after
        // each such re-render; generate() is idempotent, so the tail stays exactly one.
        //
        // Retries internally (unlike a single ready-check) because on /succes this is the
        // ONLY tagging attempt for a given lender link (no eager attemptGenerateLinks() loop
        // running alongside it, see IS_WHEEL_PATH above) — if the external DTP script (loaded
        // deferred) hasn't finished loading yet at the exact moment the user lands on a
        // lender, a one-shot check would silently skip tagging with no other chance to retry.
        window.retailOfferLinks = function () {
          var retailAttempts = 0;
          var RETAIL_MAX_ATTEMPTS = 20; // ~10s

          function attemptRetail() {
            retailAttempts++;
            var ready = window.dtpCallback && typeof window.dtpCallback.generateLinks === 'function';
            if (ready && offerAnchors().length > 0) {
              try {
                generate();
                return;
              } catch (err) {
                // Transient throw: fall through to the retry scheduling below instead
                // of giving up — same recovery behaviour as attemptGenerateLinks().
                report('retailOfferLinks threw', err);
              }
            }
            if (retailAttempts < RETAIL_MAX_ATTEMPTS) {
              setTimeout(attemptRetail, 500);
            }
            // Called on-demand (not at initial page load), so giving up silently once
            // attempts run out is fine — unlike the eager attemptGenerateLinks() loop,
            // there's no "cards should already exist" assumption to report as an anomaly.
          }

          attemptRetail();
        };
      })();

      if (${gtmEnabled} && (urlParams.has("gclid") || urlParams.has("gbraid") || urlParams.has("wbraid"))) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lead',
          transaction_id: transactionID,
        });
      }
    })();
  `
}
